module.exports = __webpack_public_path__ + "img/p1_l.d331123a.jpg";